var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5049_5779)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8 16C8.80355 14.4019 9.33865 12.8505 10.321 11.59L20.41 21.679C19.3463 22.5032 18.0728 23.0129 16.7342 23.1501C15.3955 23.2873 14.0452 23.0466 12.8363 22.4553C11.6275 21.864 10.6086 20.9458 9.89515 19.8048C9.18171 18.6638 8.80232 17.3457 8.8 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.679 20.41L11.59 10.321C12.9762 9.26747 14.6971 8.75191 16.4342 8.86978C18.1713 8.98765 19.8068 9.73097 21.0379 10.9621C22.269 12.1932 23.0123 13.8287 23.1302 15.5658C23.2481 17.3029 22.7325 19.0238 21.679 20.41Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5049_5779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.ef43946db41574c78728636d1ee76e5e.svg";
export { ForwardRef as ReactComponent };